/**
 * @generated SignedSource<<e545d2cce8adcfa398013eb1a2c104c4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftAuctionStatus = "CANCELED" | "ENDED" | "LIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ItemInternalContext_nftAuction$data = {
  readonly creatorAddress: {
    readonly address: string | null;
  } | null;
  readonly endDate: string | null;
  readonly item: {
    readonly etherRates: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"NftItemTilePrice_etherRates">;
    } | null> | null;
    readonly pdpUrl: string | null;
  } | null;
  readonly sellerAddress: {
    readonly address: string | null;
  } | null;
  readonly status: NftAuctionStatus | null;
  readonly winnerAddress: {
    readonly address: string | null;
  } | null;
  readonly " $fragmentType": "ItemInternalContext_nftAuction";
};
export type ItemInternalContext_nftAuction$key = {
  readonly " $data"?: ItemInternalContext_nftAuction$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemInternalContext_nftAuction">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "address",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemInternalContext_nftAuction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "winnerAddress",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "sellerAddress",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pdpUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EtherRates",
          "kind": "LinkedField",
          "name": "etherRates",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftItemTilePrice_etherRates"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftAuction",
  "abstractKey": null
};
})();

(node as any).hash = "a5b9445c0f758d2f8b8942d77f12ffc6";

export default node;
